import React from "react";
import styled from "styled-components";
import PlayerRankItem from "./PlayerRankItem";
import media from "cssMix/index";
import useMediaQuery from "useHooks/useMediaQuery";

const RankTableContainer = styled.div`
  width: 100%;
  & > div {
    margin-bottom: 20px;
  }
  ${media.tablet`
    padding:0;
  `}
`;
const RankHeader = styled.div`
  position: fixed;
  width: ${(props) =>
    `calc(${100 / props.column}% - ${
      360 / props.column + (10 * (props.column - 1)) / props.column
    }px)`};
  max-width: ${(props) =>
    `calc(${1440 / props.column}px - ${
      (10 * (props.column - 1)) / props.column
    }px)`};
  top: 172px;
  height: 40px;
  box-sizing: border-box;
  border-radius: 8px;
  border: solid 1px #5429af;
  background-color: rgb(41 0 135 / 45%);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  padding: 0 16px;
  z-index: 1;
  ${media.tablet`
  width: ${(props) =>
    `calc(${(100 - props.column + 1) / props.column}% - ${
      32 / props.column
    }px)`};
    height: 36px;
    font-size:13px;
    position:fixed;
    top:100px;
    z-index:8;
  `}
  & .highlight {
    color: #f9be00;
  }
  & > div:nth-of-type(2) {
    width: 72px;
  }
  & .idRound {
    flex: 1;
  }
  & .arrow {
    font-size: 12px;
    transform: scale(0.8);
    margin-left: 5px;
  }
  & .rank-title {
    cursor: pointer;
  }
`;

const PlayerRankTable = ({
  t,
  rankSortHandler,
  rankSort,
  startRank,
  playerRank,
  gameList,
  lang,
  column,
}) => {
  const rankArray =
    column === 1 ? playerRank : playerRank.slice(startRank, startRank + 10);
  const { mediaType } = useMediaQuery();
  return (
    <RankTableContainer>
      <RankHeader column={column}>
        <div className="rank-title gav2_btn_ranking" onClick={rankSortHandler}>
          {t("rank")}
          {rankSort ? (
            <i className="bx bxs-down-arrow arrow" />
          ) : (
            <i className="bx bxs-up-arrow arrow" />
          )}
        </div>
        <div></div>
        <p className="idRound">{mediaType === "pc" && t("idRound")}</p>
        <p dangerouslySetInnerHTML={{ __html: t("payout") }} />
      </RankHeader>
      {rankArray.map((v) => (
        <PlayerRankItem
          rank={v}
          key={v.get("rank")}
          gameList={gameList}
          lang={lang}
        />
      ))}
    </RankTableContainer>
  );
};

export default PlayerRankTable;
